import React, { useState, useContext } from 'react';
import { Navbar, Container, Row, Col, Button, Offcanvas } from 'react-bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './navbar.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Link, Redirect } from 'react-router-dom';

import localImage from './22.jpg';
import localImage1 from './HomeNavbar.jpg';
//import localImage2 from './login.jpg';
//import localImage3 from './Laboratorio.jpeg';
//import localImage4 from './BOTAO-GEOCONTROLE.jfif';
import marcageo from './marcageo+.png';
import Frase from './bemvindo.png';
import axios from 'axios'; // npm i axios
import Conexao from '../../Config/conexao';
import { FaGlobe, FaInstagram, FaLinkedin } from 'react-icons/fa';
import styles from './StyledButton.module.css';
function Site() {
  const [showSidebar, setShowSidebar] = useState(false);
  const [showSecondSidebar, setShowSecondSidebar] = useState(false);
  const [showSobreSidebar, setShowSobreSidebar] = useState(false);
  const [showGeocontroleSidebar, setShowGeocontroleSidebar] = useState(false);
  const [liClicked, setLiClicked] = useState(false);
  const [liClickedcor, setLiClickedcor] = useState(false);
  const [liClicked1, setLiClicked1] = useState(false);
  const [liClicked2, setLiClicked2] = useState(false);
  const [liClicked3, setLiClicked3] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [backgroundImage, setBackgroundImage] = useState(localImage);
  const [sucesso, setSucesso] = useState('');

  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');

  const images = [
    localImage,
    localImage1,
    //localImage2,
    //localImage3,
    //localImage4,
  ];

  const handleCloseSidebar = () => {
    setShowSidebar(false);
    setBackgroundImage(images[0])
  }

  const handleShowSidebar = (index) => {
    setShowSidebar(true);
    setBackgroundImage(images[index]);

  }

  const handleLiClick = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked(true);
    handleShowSecondSidebar();
    console.log(backgroundImage);
    handleCloseSobreSidebar(index); setLiClicked1(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };

  const handleCloseSecondSidebar = () => {
    setShowSecondSidebar(false);
    setBackgroundImage(images[1])
  }

  const handleShowSecondSidebar = () => {
    setShowSecondSidebar(true);
    setBackgroundImage(images[1])
  }

  const handleCloseSobreSidebar = (index) => {
    setShowSobreSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickSobre = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked1(true);
    setShowSobreSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseGeocontroleSidebar(index); setLiClicked3(false);
  };

  const handleCloseGeocontroleSidebar = (index) => {
    setShowGeocontroleSidebar(false);
    setBackgroundImage(images[index])
  }

  const handleLiClickGeocontrole = (index) => {
    setBackgroundImage(images[index]);
    setLiClicked3(true);
    setShowGeocontroleSidebar(true);
    console.log(backgroundImage);
    handleCloseSecondSidebar(index); setLiClicked(false);
    handleCloseSobreSidebar(index); setLiClicked1(false);
  };

  const togglePasswordVisibility = () => setPasswordShown(!passwordShown);

  function alterarEmail(event) {
    setUsuario(event.target.value);
  }

  function alterarSenha(event) {
    setSenha(event.target.value);
  }



  function SalvaUser() {
    localStorage.usuario = document.getElementById("floatingInput").value;
  }

  return (
    <div className="home">
      <div className="banner" style={{ backgroundImage: `url(${backgroundImage})` }}>
        <Container>
          <div>

            <div className="text-center">
              {showSidebar === false ? <div className="image-wrapper">
                <img src={marcageo} className="image-adjust" alt="Descrição" />
                <img src={Frase} className="image-adjust" alt="Descrição" />
              </div> : null}
            </div>

          </div>
        </Container>
        <div className="sidebar-button">
          <Button variant="success" onClick={() => { handleShowSidebar(1) }} className="custom-button">
            <div className="icon-container">
              <i className="bi bi-list icon-circle"></i>
            </div>
          </Button>
        </div>
      </div>
      <div className="language-buttons">
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraBrasil.png" alt="Brasil" className="language-flag" />
        </Button>
        <Button variant="outline" className="rounded-circle">
          <img src="../Images/BandeiraPortugal.png" alt="Português" />
        </Button>
      </div>

      {/* Sidebar Login */}
      <Offcanvas show={showSidebar} onHide={handleCloseSidebar} className="first-sidebarNav">
  <div className="offcanvas-header">
    <button type="button" className="btn-close custom-btn-close" data-bs-dismiss="offcanvas" onClick={() => { handleCloseSidebar(1) }} aria-label="Close"></button>
  </div>
  <Offcanvas.Body>
    <ul >
      <li className={`${liClicked ? 'li-slide-right' : ''}`}>
        <Link to="/app/Laboratorio" style={{ textDecoration: 'none' }}>
          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Laboratório</button>
        </Link>
      </li>
      <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
        <Link to="/app/TelaSondagem" style={{ textDecoration: 'none' }}>
          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Sondagem Geotécnica</button>
        </Link>
      </li>
      <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
        <Link to="/app/PesquisaMineral_Inicio" style={{ textDecoration: 'none' }}>
          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Pesquisa Mineral</button>
        </Link>
      </li>
      <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
        <Link to="/app/SSMA" style={{ textDecoration: 'none' }}>
          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>SSMA</button>
        </Link>
      </li>
      <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
        <Link to="/app/SGI" style={{ textDecoration: 'none' }}>
          <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>SGI</button>
        </Link>
      </li>
      <div className="offcanvas-footer">
        <li className={liClicked1 ? 'li-slide-right' : ''} onClick={() => handleLiClickSobre(3)}>
          <Link to="/#" style={{ textDecoration: 'none' }}>
            <button className="btn btn-success mt-4 btn-block hover-effect" style={{ borderRadius: '100px', width: '70%', height: '50px', display: 'block', marginLeft: 'auto', marginRight: 'auto', fontSize: '20px' }}>Sair</button>
          </Link>
        </li>
      </div>
    </ul>
  </Offcanvas.Body>
</Offcanvas>

    
    </div>
  );
}

export default Site;
